export { default } from './ProductCharacteristics';
